// 帮助中心-视频教程组件使用
import * as types from '@/store/mutations-types'

// state
const state = {
  permissionData: [], // 新增弹窗
  currentPermission: []
}
// action
const action = {}
// mutations
const mutations = {
  [types.PERMISSION] (state, permissionData) {
    state.permissionData = permissionData
  },
  [types.CURRENT_PERMISSION] (state, currentPermission) {
    state.currentPermission = currentPermission
  }
}

export default {
  state,
  action,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/permission.js